module.exports = __webpack_public_path__ + "static/media/ic_upload.ebd8d197.svg";